<script lang="ts">
	import { SidepanelContent } from '@Shelly/shelly-design-system/index';
	//Components
	import EventLog from 'src/components/EventLog/EventLog.svelte';
	import EvChargeEventLog from 'src/components/XT1/EvCharger/EventLog/EvChargeEventLog.svelte';
	//Types
	import type { Device } from 'src/types/Device.ts';

	export let device: Device;
	export let openedEventTimestamp: number | null = null;
</script>

<SidepanelContent>
	{#if device?.category === 'charger'}
		<EvChargeEventLog {device} />
	{:else}
		<EventLog {device} type={'device'} {openedEventTimestamp} />
	{/if}
</SidepanelContent>
